var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row justify-content-center no-gutters main-mr container-fluid"
    },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { attrs: { id: "boards-section" } }, [
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "col d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "h4",
                  {
                    staticClass:
                      "mb-0 fw-weight font-24 my-project-font-sm active"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$resourceString["account.MyTray.Title"]) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.selectedTab !== "Archived"
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary ",
                        attrs: { href: _vm.addTrayHref },
                        on: { click: _vm.handleAddTray }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "png-icon bg-light position-relative png-icon-icons-glyph--ko-plus bg-transparent mb-1 mr-2",
                          staticStyle: { width: "25px", height: "25px" }
                        }),
                        _vm._v(" "),
                        _c("span", {}, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$resourceString[
                                  "account.MyTray.Button.AddTray"
                                ]
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedTab === "Archived" && _vm.showComponentpcBoardCard
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn call-to-action-button btn-primary px-0 justify-content-center",
                          class: { disabled: _vm.isDisabled },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.handleDeleteTray($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$resourceString[
                                  "common.Button.Title.Delete"
                                ]
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn call-to-action-button btn-primary px-0 justify-content-center ml-lg-3 ",
                          class: { disabled: _vm.isDisabled },
                          on: { click: _vm.handleArchiveTray }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$resourceString[
                                  "account.MyTray.Button.Reactivate"
                                ]
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center mb-3" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-xl-7 col-lg-9 col-md-9 col-12 pr-0 pb-2"
              },
              [_c("pc-my-trays-tabs")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-xl-3 col-lg-3 col-md-3 col-12" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex h-100 align-items-center justify-content-center justify-content-sm-end"
                  },
                  [
                    _c("pc-layout-button", {
                      attrs: { toggleLayout: _vm.toggleLayout }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("pc-search", { attrs: { cols: null } }),
              _vm._v(" "),
              _c("pc-sort-by")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-lg-12 p-0" },
            [
              _vm.showComponentpcBoardCard
                ? _c("pc-board-card", {
                    attrs: {
                      layoutToRenderIsSmall: _vm.layoutToRenderIsSmall,
                      isAdminMode: _vm.isAdmin
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.showComponentpcBoardCard
                ? _c("pc-board-list-view", {
                    attrs: { isAdminMode: _vm.isAdmin }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showLoadMore
                ? _c("pc-load-more", { attrs: { "load-more": _vm.onLoadMore } })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "650",
            name: "share-tray-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true
          }
        },
        [
          _c("pc-vt-share-tray-modal", {
            attrs: { userEmail: _vm.user.user ? _vm.user.user.email : "" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }